import { Button, CircularProgress, Typography } from '@material-ui/core';
import React from 'react';
import styled from 'styled-components';

import useServiceList from 'core/hooks/useServiceList';
import currency from 'Elements/Formats/currency';
import {
  Body,
  Column,
  GridTable,
  Header,
  Row as GridRow,
} from 'Elements/GridTable';

const Row = styled(GridRow)`
  grid-template-columns: 70px minmax(150px, 1fr) 100px 100px;
`;

const CenterColumn = styled(Column)`
  grid-column: 1 / 6;
  display: flex;
  justify-content: center;
`;

export default function ServicesTable() {
  const { data: services, loading, hasMore, loadMore } = useServiceList();

  return (
    <GridTable>
      <Header>
        <Row>
          <Column>Koodi</Column>
          <Column>Nimi</Column>
          <Column>Hinta</Column>
        </Row>
      </Header>

      <Body>
        {services.map((service) => (
          <Row hover>
            <Column>{service.code}</Column>
            <Column>{service.title}</Column>
            <Column>{currency.format(service.price)}</Column>
          </Row>
        ))}
        <Row>
          <CenterColumn>
            {loading && <CircularProgress />}

            {!loading && hasMore && (
              <Button variant="contained" color="primary" onClick={loadMore}>
                Lataa lisää
              </Button>
            )}

            {!loading && !hasMore && (
              <Typography variant="subtitle1">Ei enempää palveluita</Typography>
            )}
          </CenterColumn>
        </Row>
      </Body>
    </GridTable>
  );
}
